import $ from "jquery";
import apiFetch from "@wordpress/api-fetch";
import { smoothscroll } from "../utils/smoothscroll";
import { resizeTextAreas } from "./comment";

const $window = $(window);
const $body = $(".page");

const actions = (element, index) => {
  const $menu = element.parent().children(".post-card__comment-actions");
  const $content = element
    .closest(".post-card__comment-field")
    .find(".post-card__comment-text");
  const $cancel = element
    .closest(".post-card__comment-field")
    .find(".post-card__close");
  const $editInput = element
    .closest(".post-card__comment-field")
    .find(".post-card__comment-edit");
  const $edit = element.parent().find(".post-card__comment-actions-edit");
  const $delete = element.parent().find(".post-card__comment-actions-delete");

  element.off("click");
  element.on("click", function (event) {
    event.stopPropagation();
    toggleMenu($menu);
  });

  $edit.off("click");
  $edit.on("click", () => {
    showEdit($editInput, $content);
  });

  $body.off("click.comment" + index);
  $body.on("click.comment" + index, () => hideMenu($menu));

  $body.off("keydown.comment" + index);
  $body.on("keydown.comment" + index, function (event) {
    if (event.key === "Escape") {
      hideMenu($menu);
    }
  });

  $window.off("resize:width.comment" + index);
  $window.on("resize:width.comment" + index, () => hideMenu($menu));

  $cancel.off("click");
  $cancel.on("click", () => hideEdit($editInput, $content));

  $delete.off("click");
  $delete.on("click", async () => {
    const data = {
      commentId: $delete.closest(".post-card__comment").data("comment"),
    };

    const result = await deleteComment(data);
    if (result === true) {
      $delete.closest(".post-card__comment").remove();
    }
  });
};

const toggleMenu = ($menu) =>
  $menu.hasClass("post-card__comment-actions--active")
    ? hideMenu($menu)
    : showMenu($menu);

const showMenu = ($menu) => {
  hideMenu($(".post-card__comment-actions"));
  $menu.addClass("post-card__comment-actions--active");
};

const hideMenu = ($menu) =>
  $menu.removeClass("post-card__comment-actions--active");

const showEdit = ($edit, $content) => {
  $content.removeClass("post-card__comment-text--active");
  $edit.addClass("post-card__comment-edit--active");

  const $commentField = $edit.closest(".post-card__comment-field");

  $commentField
    .find(".post-card__comment-actions-button")
    .addClass("post-card__comment-actions-button--hidden");

  const $textArea = $commentField.find(".post-card__textarea");
  $textArea.data("val", $textArea.val());

  resizeTextAreas($textArea);
};

const hideEdit = ($edit, $content) => {
  $content.addClass("post-card__comment-text--active");
  $edit.removeClass("post-card__comment-edit--active");

  const $commentField = $edit.closest(".post-card__comment-field");

  $commentField
    .find(".post-card__comment-actions-button")
    .removeClass("post-card__comment-actions-button--hidden");

  const $textArea = $commentField.find(".post-card__textarea");
  $textArea.val($textArea.data("val"));
};

const deleteComment = async (data) => {
  try {
    const response = await apiFetch({
      path: "/xixoio/v1/comment/delete/" + data.commentId,
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
      }),
      data: data,
    });

    return response;
  } catch (e) {
    console.log(e);
    return null;
  }
};

export const reloadScriptActions = () => {
  const $actions = $(".post-card__comment-actions-button");

  $actions.each(function (index) {
    actions($(this), index);
  });
};
reloadScriptActions();

/* ------------------------------------------------------ */

const commentElInit = (el) => {
  const data = {
    postId: el.closest(".post-card__comments-wrapper").data("post"),
    commentId: el.data("comment"),
    content: "",
  };

  bindCommentTextarea(el, data);
};

const bindCommentTextarea = (element, data) => {
  element.off("submit", ".post-card__comment-edit");
  element.on("submit", ".post-card__comment-edit", function (e) {
    e.preventDefault();
    const $thisEl = $(this);

    data.content = $thisEl.find(".post-card__textarea").val();

    if (data.commentId == $thisEl.data("comment")) {
      reRenderCommentsEl(element, data);
    }
  });
};

const reRenderCommentsEl = async (element, data) => {
  const result = await updateComment(data);
  element
    .closest(`.post-card__comments-wrapper[data-post='${data.postId}']`)
    .html(result.html);

  await smoothscroll(
    `.post-card__comment[data-comment='${data.commentId}']`,
    "header"
  );

  reloadScriptActions();
  reloadScriptCommentEdit();
};

const updateComment = async (data) => {
  try {
    const response = await apiFetch({
      path: "/xixoio/v1/comment/edit/" + data.commentId,
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
      }),
      data: data,
    });

    return response;
  } catch (e) {
    console.log(e);
    return null;
  }
};

export const reloadScriptCommentEdit = () => {
  const $commentEl = $(".post-card__comment");

  $commentEl.each(function () {
    commentElInit($(this));
  });
};
reloadScriptCommentEdit();
